module.exports = __webpack_public_path__ + "images/kuperus_smallb8a33620697f65e278a223553d77c2b3.png";